import { render } from 'preact';
import { App } from './App.js';
import './index.css';

render(<App />, document.getElementById('app')!);
